<template>
  <inventoryProductsCategoriesForm :typeEndPoint="'inventoryProductsSubCategoriesShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsCategoriesForm from '@/components/modules/papeleria/products/subcategories/form'
export default {
  name: 'inventoryProductsCategories',
  components: {
    inventoryProductsCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/subcategories/edit.vue